import { Component } from 'react';

import { Topic } from '~src/interfaces/topic.interface';
import { Question } from '~src/interfaces/question.interface';
import { QuestionSubmit } from '~src/modules/topics/actions/topicActions';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import ListAddForm from '~src/modules/surveys/components/topic_select/ListAddForm';

import { InnerAddWrapper } from './topicQuestions.sc';
import TopicSection from './TopicSection';

interface OwnProps {
  topic: Topic;
  selectAll: (topic: Topic, value: boolean) => Promise<void>;
  selectedQuestions: { [key: string]: boolean };
  mandatoryQuestions: string[];
  addQuestion: (topicUuid: string, value: QuestionSubmit) => ApiReduxResp<Question>;
  defaultContentLocale: string;
  isCreated: boolean;
  changeShowSave: (value: boolean) => void;
  isPrivate?: boolean;
  change(field: string, value: boolean): void;
}

type Props = OwnProps;

class TopicQuestions extends Component<Props> {
  addQuestion = (value: string) => {
    return new Promise((res, rej) => {
      this.props
        .addQuestion(this.props.topic.id, {
          title: { [this.props.defaultContentLocale]: value },
          selfTitle: { [this.props.defaultContentLocale]: value },
        })
        .then((resp) => {
          if (resp.response) {
            this.props.change(`questions.${resp.topicId}.${resp.response.data.id}`, false);
            res(resp);
          } else {
            rej(resp);
          }
        })
        .catch((err) => {
          rej(err);
        });
    });
  };

  renderAddForm = () => (
    <InnerAddWrapper $empty={!this.props.topic.questions}>
      <ListAddForm
        isSurveyScopePrivate={this.props.isPrivate}
        inputLabelKey="x.survey.details.topic.form.add.question.label"
        addTextKey="x.survey.details.topic.form.add.question.button"
        submitForm={this.addQuestion}
        openAndSelected={
          this.props.isCreated && !(this.props.topic.questions && this.props.topic.questions.length > 0)
        }
        showTopicScale={this.props.topic.id  || undefined}
      />
    </InnerAddWrapper>
  );

  render() {
    const { topic } = this.props;
    return (
      <TopicSection
        changeShowSave={this.props.changeShowSave}
        topic={topic}
        selectAll={this.props.selectAll}
        selectedQuestions={this.props.selectedQuestions}
        mandatoryQuestions={this.props.mandatoryQuestions}
        defaultContentLocale={this.props.defaultContentLocale}
        isCreated={this.props.isCreated}
        renderAddForm={this.renderAddForm}
      />
    );
  }
}

export default TopicQuestions;
